import React, { Component } from 'react';
import { Redirect } from 'react-router';

export interface PropsFromState {
    isLoggedIn: boolean
}

export interface PropsFromDispatch {
    loginCallback: () => void
}

class LoginCallback extends Component<PropsFromState & PropsFromDispatch, any> {

    public componentDidMount() {
        this.props.loginCallback();
    }

    render() {

        const redirect = this.props.isLoggedIn

        return (
            <div>
                { redirect &&
                    <Redirect to="/" />
                    }
                    <h1>Swapping code for a token.</h1>
                </div>
        );
    }
}

export default LoginCallback;
